<template>
    <header v-if="showLandingview" class="landingpage" v-bind:class="{open: animateShowPage}" v-on:click="showPage">
        <img class="centered-logo" src="../assets/Logo-light.png">
        <div class="triangle left">
            <div class="top-left-vertical-container">
                <div class="top-left-vertical">recruiting</div>
                <div class="top-left-vertical">training</div>
            </div>
            <div class="top-left-horizontal-container">
                <div class="top-left-vertical">coaching</div>
                <div class="top-left-vertical">moderation</div>
            </div>
        </div>
        <div class="triangle right"></div>
    </header>
</template>

<script>
    export default {
        name: "Landingview",
        data() {
            return {
                animateShowPage: false
            }
        },
        computed: {
            showLandingview() {
                return this.$store.state.isLandingView
            }
        },
        methods: {
            showPage() {
                this.animateShowPage = true
                this.$store.dispatch('hideLandingview')
            }
        },
        watch: {
            showPage(newVal, oldVal) {
                setTimeout(() => {
                    this.showLandingpage = false
                }, 800)
            }
        },
        beforeCreate() {
            document.body.className = "home-page"
        }
    }
</script>

<style lang="sass" scoped>
    .landingpage
        position: fixed
        width: 100vw
        height: 100vh
        top: 0
        left: 0
        z-index: 1000
        display: flex
        background-color: #000


        .centered-logo
            max-width: 80%
            opacity: 1
            position: fixed
            height: 65vh
            width: auto
            top: 50%
            left: 50%
            transform: scale(1) translate(-50%, -50%)
            z-index: 1001
            transition: opacity .8s
            cursor: pointer
            transition: all 200ms ease-in
            -webkit-transform-origin: 50% 50%
            -moz-transform-origin: 50% 50%
            transform-origin: 50% 50%


            &:hover
                transform: scale(1.015) translate(-50%, -50%)
                -webkit-transform-origin: 50% 50%
                -moz-transform-origin: 50% 50%
                transform-origin: 50% 50%

        .triangle
            position: absolute
            z-index: 1
            top: 0
            left: 0
            width: 100%
            height: 100%
            background: #000
            transition: all .8s cubic-bezier(0.645, 0.045, 0.355, 1)
            display: flex
            justify-content: center
            align-items: center
            pointer-events: none

            > div
                color: white
                font-size: 20px
                position: absolute
                font-family: "GT Walsheim Regular"

                &.top-left-vertical-container
                    top: 103px
                    left: 30px
                    transform: rotate(-90deg) translate(-100%, 0)
                    transform-origin: 0 0
                    display: flex
                    flex-direction: row

                    > div
                        margin-right: 50px

                        &:last-child
                            margin-right: 0


                &.top-left-horizontal-container
                    top: 30px
                    left: 103px
                    display: flex
                    flex-direction: row

                    > div
                        margin-right: 50px

                        &:last-child
                            margin-right: 0

                &.top-left-vertical


                &.top-left-horizontal
                    top: 30px
                    left: 80px

                &.top
                    top: 10px

                &.left
                    left: 10px

                &.bottom
                    bottom: 10px

                &.right
                    right: 10px

                &.vertical


                    &.left
                        top: 40px


            &.left
                clip-path: polygon(100% 0, 0 0, 0 100%)


            &.right
                clip-path: polygon(100% 0, 100% 100%, 0 100%)

        &.open
            background-color: transparent

            .triangle
                &.left
                    clip-path: polygon(100% 0, 0 0, 0 0)

                &.right
                    clip-path: polygon(100% 100%, 100% 100%, 0 100%)

            .centered-logo
                opacity: 0



    @media (max-width: 700px)
        header.landingpage > div.triangle.left > div
            display: none


    @media (max-width: 900px)
        .landingpage > img.centered-logo:hover
            transform: translate(-50%, -50%)


</style>